import { Body1, Text, makeStyles, tokens } from '@fluentui/react-components';

import type { ClientObservedSignal } from '@/api/types';

const useStyles = makeStyles({
  root: { display: 'flex', flexDirection: 'column', gap: '4px' },
  muted: { color: tokens.colorNeutralForeground3 },
});

interface ClientObservedSignalSummaryProps {
  label: string;
  signals: readonly ClientObservedSignal[];
}

export function ClientObservedSignalSummary({ label, signals }: ClientObservedSignalSummaryProps) {
  const classes = useStyles();
  if (signals.length === 0) {
    return <Body1 className={classes.muted}>{label}: Unsupported</Body1>;
  }
  return (
    <div className={classes.root} aria-label={label}>
      {signals.map((signal, index) => (
        <Body1 key={`${signal.sourceResourceId}-${signal.targetResourceId ?? 'request'}-${String(index)}`}>
          <Text weight="semibold">{`${label} · ${signal.sourceResourceId}: `}</Text>
          {signal.state === 'Measured'
            ? `Measured · ${signal.availabilityPct?.toFixed(2) ?? '—'}% availability · p95 ${signal.p95DurationMs?.toFixed(0) ?? '—'} ms · ${signal.attempts.toLocaleString()} attempts`
            : signal.state === 'Unknown'
              ? `Unknown · ${signal.attempts.toLocaleString()} attempts`
              : signal.state}
          <span className={classes.muted}>{` · ${new Date(signal.windowStartMs).toLocaleString()}–${new Date(signal.windowEndMs).toLocaleString()}`}</span>
        </Body1>
      ))}
    </div>
  );
}
